var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositionsBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".positions-icon-blue{fill:#2667ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "positions-icon-blue",
    d: "M20.61,22.4h8.78v2.8H20.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "positions-icon-blue",
    d: "M40.56,25.2H32.32v1.4A1.43,1.43,0,0,1,30.86,28H19.14a1.43,1.43,0,0,1-1.46-1.4V25.2H9.44a4.37,4.37,0,0,1-4.17-2.87L0,7.22V37.8A4.3,4.3,0,0,0,4.39,42H45.61A4.3,4.3,0,0,0,50,37.8V7.23l-5.27,15.1A4.37,4.37,0,0,1,40.56,25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "positions-icon-blue",
    d: "M30.86,0H19.14a4.3,4.3,0,0,0-4.39,4.2V5.6H2.52L8.05,21.44a1.44,1.44,0,0,0,1.39,1h8.24V21a1.43,1.43,0,0,1,1.46-1.4H30.86A1.43,1.43,0,0,1,32.32,21v1.4h8.24a1.44,1.44,0,0,0,1.39-1L47.48,5.6H35.25V4.2A4.3,4.3,0,0,0,30.86,0ZM17.68,5.6V4.2a1.43,1.43,0,0,1,1.46-1.4H30.86a1.43,1.43,0,0,1,1.46,1.4V5.6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionsBlue);
export default __webpack_public_path__ + "static/media/positions-blue.a5869bc4.svg";
export { ForwardRef as ReactComponent };